module.exports = __webpack_public_path__ + "img/do_request_button_hover.61cb0ee2.png";